import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/style/style.css';
import { library } from '@fortawesome/fontawesome-svg-core';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSync, faUserCog, faUserCheck, faHome,
  faHourglassHalf, faUserTimes, faServer, faEnvelope, faKey,
  faPaperPlane, faUserCircle, faCheckCircle, faExclamationTriangle, faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import App from './components/App.jsx';
import Footer from './components/Footer.jsx';
import '../assets/img/logoRhx.png';
import FormsBox from './containers/FormsBox';
import reducers from './reducers';

library.add(faSync, faUserCog, faUserCheck, faHome, faHourglassHalf,
  faUserTimes, faServer, faEnvelope, faKey, faPaperPlane, faUserCircle,
  faCheckCircle, faExclamationTriangle, faSpinner);

// eslint-disable-next-line no-underscore-dangle
// const ext = window.__REDUX_DEVTOOLS_EXTENSION__;
// const devtoolMiddleware = ext && ext();

const store = createStore(
  reducers,
  compose(
    applyMiddleware(thunk),
    // devtoolMiddleware,
  ),
);
ReactDOM.render(
  <Provider store={store}>
  <App><FormsBox/></App><Footer/>
  </Provider>,
  document.getElementById('app'),
);
